// The widest of a dropdown's possible labels, approximated by length, for FiltersWrapper `reservedValue`.
const longestLabel = labels => labels.reduce((longest, label) => (label.length > longest.length ? label : longest), '')

export default longestLabel
